/* eslint @typescript-eslint/no-explicit-any: 0 */
import { getIconRegistry } from "./registry";

describe(`IconRegistry`, () => {
    beforeEach(() => {
        delete (window as any).trumpf;
        document.body.className = "ux-theme-web";
    });

    it(`should detect theme correctly`, () => {
        document.body.className = "ux-theme-web";
        expect(getIconRegistry().theme).toEqual("web");
        expect(getIconRegistry().assetsPath).toEqual("/themes/web/assets/icons/svg/");

        delete (window as any).trumpf;
        document.body.className = "ux-theme-responsive";
        expect(getIconRegistry().theme).toEqual("responsive");
        expect(getIconRegistry().assetsPath).toEqual("/themes/responsive/assets/icons/svg/");
    });

    it(`should handle uxThemeChange event correctly`, async () => {
        document.body.className = "ux-theme-web";
        expect(getIconRegistry().theme).toEqual("web");

        document.body.className = "ux-theme-responsive";
        document.dispatchEvent(new Event("uxThemeChange", { bubbles: true }));
        await new Promise((res) => setTimeout(res, 1));
        expect(getIconRegistry().theme).toEqual("responsive");
        expect(getIconRegistry().assetsPath).toEqual("/themes/responsive/assets/icons/svg/");

        getIconRegistry().setTheme("web");
        document.body.className = "ux-theme-responsive";
        document.dispatchEvent(new Event("uxThemeChange", { bubbles: true }));
        await new Promise((res) => setTimeout(res, 1));
        expect(getIconRegistry().theme).toEqual("web");
    });

    it(`getIconRegistry() should return the global singleton instance`, () => {
        const iconRegistry = getIconRegistry();
        expect(iconRegistry).toBe(getIconRegistry());
        expect((window as any).trumpf.ux.iconRegistry).toBe(getIconRegistry());
    });

    it(`setAssetsPath() should explicitly set the icon assetsPath`, () => {
        getIconRegistry().setAssetsPath("/test/assets/");
        expect(
            getIconRegistry().resolveAssetUrl({
                name: "bin",
                filled: false,
                weight: "normal"
            })
        ).toEqual("/test/assets/bin--normal.svg");
        expect((window as any).trumpf.ux.iconRegistry).toBe(getIconRegistry());
    });

    it(`registerIcon() should add an icon to the built-in library`, () => {
        getIconRegistry().setAssetsPath("/test/assets/");
        expect(
            getIconRegistry().registerIcon({
                name: "custom-icon",
                outlineWeights: ["normal", "light", "bold"],
                filledWeights: ["bold"]
            })
        ).toBe(getIconRegistry());
        expect(
            getIconRegistry().resolveAssetUrl({
                name: "custom-icon"
            })
        ).toEqual("/test/assets/custom-icon--normal.svg");
        expect(
            getIconRegistry().resolveAssetUrl({
                name: "custom-icon",
                filled: true
            })
        ).toEqual("/test/assets/custom-icon--filled--bold.svg");
        expect(
            getIconRegistry().resolveAssetUrl({
                name: "unknown-icon"
            })
        ).toEqual(null);
    });

    it(`registerIconSet() should register an icon-set with scoped namespace and asset path`, () => {
        expect(
            getIconRegistry().registerIconSet({
                ns: "app",
                assetsPath: "/test/assets/",
                fileExtension: ".svg"
            })
        ).toBe(getIconRegistry());
        expect(
            getIconRegistry().resolveAssetUrl({
                name: "app:custom-asset"
            })
        ).toEqual("/test/assets/custom-asset.svg");
        expect(
            getIconRegistry().resolveAssetUrl({
                name: "app:custom-asset",
                filled: true,
                weight: "bold"
            })
        ).toEqual("/test/assets/custom-asset--filled--bold.svg");
        expect(
            getIconRegistry().resolveAssetUrl({
                name: "unknown:custom-asset"
            })
        ).toEqual(null);
    });
});
